// size can be 'sm', 'md', 'lg', default='lg'

export default ({ message, loaderClass, size, style }) => (
  <div
    role="progressbar"
    aria-valuetext="Loading..."
    className={`${loaderClass || 'cb-loader-gray'} cb-loader cb-loader-${size || 'lg'}`}
    style={style || { margin: '25px auto' }}
  >
    <span className="sr-only">{message || 'Loading...'}</span>
  </div>
)
